export default "__VITE_ASSET__cksTNtmo__"